module.exports = __webpack_public_path__ + "static/media/black_hand.3753d71e.png";